module.exports = __webpack_public_path__ + "img/fb_logo.1dd79521.svg";